import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Repeat, Flame, Timer } from 'lucide-react';
const problems = [{
  icon: Repeat,
  text: 'Siempre las mismas recetas'
}, {
  icon: Flame,
  text: 'La comida queda seca o sin sabor'
}, {
  icon: Timer,
  text: 'No sabés los tiempos ni temperaturas'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ProblemSection() {
  return <section className="w-full py-12 md:py-20 px-6 bg-surface" data-id="element-372">
      <div className="max-w-[900px] mx-auto text-center" data-id="element-373">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-3xl md:text-4xl font-serif mb-12 text-charcoal" data-id="element-374">
          ¿Tenés la freidora guardada sin saber qué hacer?
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-375">
          {problems.map((problem, index) => <motion.div key={index} variants={itemVariants} className="bg-background rounded-2xl p-8 shadow-soft flex flex-col items-center text-center" data-id="element-376">
              <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mb-6 text-primary" data-id="element-377">
                <problem.icon className="w-7 h-7" strokeWidth={2} data-id="element-378" />
              </div>
              <p className="text-lg font-medium text-charcoal leading-snug" data-id="element-379">
                {problem.text}
              </p>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-12" data-id="element-380">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => {
          window.location.href = 'https://valordigital.store/cart/46518849142973:1';
        }} className="w-full md:w-auto bg-primary hover:bg-primary-hover text-white font-bold uppercase tracking-wider py-4 px-8 rounded-xl shadow-soft transition-colors text-base" data-id="element-381">
            Solucioná esto hoy →
          </motion.button>
        </motion.div>
      </div>
    </section>;
}